import type { OpenTicketHandoff } from '../types/users';

// Who takes over a departing member's tickets that aren't closed:
// '' = not chosen yet, 'unassign' = leave them unassigned, otherwise the user ID taking them over
export type HandoffChoice = string;

export function toOpenTicketHandoff(choice: HandoffChoice): OpenTicketHandoff {
  if (choice === 'unassign') return { unassignOpenTickets: true };
  return choice ? { reassignOpenTicketsToUserId: choice } : {};
}

// " 3 tickets reassigned to Jane." for the success toast; empty when nothing was handed off
export function describeHandoff(count: number, choice: HandoffChoice, assigneeName?: string): string {
  if (count === 0) return '';
  const tickets = count === 1 ? '1 ticket' : `${count} tickets`;
  return choice === 'unassign'
    ? ` ${tickets} unassigned.`
    : ` ${tickets} reassigned to ${assigneeName ?? 'the new assignee'}.`;
}
